import { ReactElement, ReactNode } from 'react'

import { ThemeProvider } from 'styled-components'
import { GlobalTokens } from './GlobalTokens'
import { ZingTheme } from './types'
import { lightTheme } from './theme'

interface DarkThemeProviderProps {
  children: ReactNode
  theme?: Partial<ZingTheme>
}

export const DarkThemeProvider = ({ children, theme }: DarkThemeProviderProps): ReactElement => (
  <ThemeProvider theme={{ ...lightTheme, ...(theme ?? {}), theme: lightTheme }}>
    <GlobalTokens />
    {children}
  </ThemeProvider>
)
